module.exports = __webpack_public_path__ + "static/media/foto_stanza_albergo2_comp.edf26d1b.jpg";